import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import UserAddressDisplay from '../../../user-address/UserAddressDisplay';
import Button from '../../../Button';
import UserAddressForm from '../../../user-address/UserAddressForm';

const propTypes = {
  userId: PropTypes.string,
  createAccountAddress: PropTypes.func,
  address: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string,
    address_line_1: PropTypes.string,
    address_line_2: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    post_code: PropTypes.string,
    country: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    }),
  }),
  className: PropTypes.string,
  onAddressConfirm: PropTypes.func.isRequired,
  onSkip: PropTypes.func,
};

const CustomPrintAddressSelect = ({
  address,
  className,
  onAddressConfirm,
  onSkip,
  userId,
  createAccountAddress,
}) => {
  const hasExistingAddress = !!address;
  const [newAddress, setNewAddress] = useState(!hasExistingAddress);
  const classes = classNames({
    'custom-print-address-select': true,
    [className]: !!className,
  });

  return (
    <div className={classes}>
      {hasExistingAddress && !newAddress ? (
        <Fragment>
          <p className="text-extra-bold text-dark mb-1">Confirm address</p>
          <p className="text-italic text-sm lh-normal">
            Before continuing, please confirm that the following shipping
            address for this print is correct.
          </p>

          <UserAddressDisplay
            address={address}
            title={null}
            className="user-address-alt mt-4 mb-6"
          />

          <div className="text-center">
            <Button
              btnStyle="link"
              btnBlock
              className="mb-3 text-bold"
              onClick={() => setNewAddress(true)}
            >
              Ship to a different address
            </Button>

            <Button
              data-testid="confirm-button"
              btnSize="lg"
              btnBlock
              onClick={() => onAddressConfirm(address)}
            >
              Confirm address
            </Button>
          </div>
        </Fragment>
      ) : (
        <Fragment>
          {!hasExistingAddress ? (
            <p className="text-center">
              Please provide the address you&rsquo;d like this print to be
              shipped to before continuing:
            </p>
          ) : (
            <p className="text-center">
              Ship this print to the following address:
            </p>
          )}

          <UserAddressForm
            formLabel=""
            userId={userId}
            createAccountAddress={createAccountAddress}
            onSuccess={onAddressConfirm}
            onCancel={
              hasExistingAddress ? () => setNewAddress(false) : undefined
            }
          />
        </Fragment>
      )}

      {onSkip && (
        <div className="text-center mt-4">
          <Button
            btnStyle="link"
            btnSize="sm"
            className="text-color-base"
            onClick={onSkip}
          >
            Skip and do it later
          </Button>
        </div>
      )}
    </div>
  );
};

CustomPrintAddressSelect.propTypes = propTypes;

export default CustomPrintAddressSelect;
